import React from "react";

import { useCheckIsMobile } from "@sellernote/shared/src/utils/hook";
import useOnceActivatedIntersectionObserver from "@sellernote/features/src/common/hooks/useOnceActivatedIntersectionObserver";
import CommonStyled from "@sellernote/shipda-kr/src/components/landing/index.styles";
import LinkButton from "@sellernote/ui/src/sds-v2/components/button/Button/LinkButton";
import FourChevronRightIcon from "@sellernote/ui/src/sds-v2/components/svgIcons/FourChevronRightIcon";
import { TEXT_COLOR } from "@sellernote/ui/src/sds-v2/styles/colors";

import Styled from "./index.styles";

export default function LandingSectionRecruit({
  title,
  desc,
  backgroundImageUrl,
  backgroundMobileImageUrl,
  buttonInfo,
}: {
  title: React.ReactNode;
  desc: React.ReactNode;
  backgroundImageUrl: string;
  backgroundMobileImageUrl: string;
  buttonInfo: { label: React.ReactNode; href: string };
}) {
  const { isMobile } = useCheckIsMobile();

  const { target, isActivatedTarget } = useOnceActivatedIntersectionObserver({
    threshold: 0.3,
  });

  return (
    <Styled.container
      ref={target}
      backgroundImageUrl={
        isMobile ? backgroundMobileImageUrl : backgroundImageUrl
      }
    >
      <Styled.contents>
        <CommonStyled.sectionTitle
          textColor={TEXT_COLOR.white_1}
          className={`fade-up-animation ${isActivatedTarget ? "active" : ""}`}
        >
          {title}
        </CommonStyled.sectionTitle>

        <p className={`fade-up-animation ${isActivatedTarget ? "active" : ""}`}>
          {desc}
        </p>

        <Styled.buttonContainer
          className={`fade-up-animation ${isActivatedTarget ? "active" : ""}`}
        >
          <LinkButton
            theme="tertiary"
            borderType="filled"
            size="normal"
            label={buttonInfo.label}
            href={buttonInfo.href}
            iconInfo={{
              Icon: FourChevronRightIcon,
              position: "right",
            }}
            className="custom-recruit-button"
          />
        </Styled.buttonContainer>
      </Styled.contents>
    </Styled.container>
  );
}
